/** 
 * © 2025 COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 'CONTPAQi'. Todos los derechos reservados. 
 * Este código fuente constituye una obra original protegida por la legislación nacional e internacional en materia de propiedad intelectual. 
 * Su reproducción, distribución, comunicación pública, transformación, descompilación, ingeniería inversa o cualquier uso no autorizado, 
 * total o parcial, se encuentra expresamente prohibido sin la previa autorización por escrito de COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 
 * El uso indebido de este software puede ser constitutivo de delitos y dará lugar a las responsabilidades civiles y penales correspondientes. 
*/ 
 
import { BaseAction } from '../../types/global.type';
import * as actions from '../../types/initialization-action.type';

export type InitializationState = {
  isSetting: boolean,
  isChecking: boolean,
  error?: any,
  status?: any,
};

const initialState: InitializationState = {
  isSetting: true,
  isChecking: false,
  error: undefined,
  status: undefined,
};

export const initializationReducer = (
  state: InitializationState = initialState,
  action: BaseAction
) => {
  switch (action.type) {
    case actions.SET_INITIALIZE:
      return {...state, isSetting: true, error: undefined, isChecking: true}
    case actions.SET_INITIALIZE_SUCCESS:
      return {...state, error: undefined, status: action.payload, isSetting: false}
    case actions.SET_INITIALIZE_FAILURE:
      return {...state, error: action.payload, isSetting: false}
    default:
      return state;
  }
};
